<template>
    <div class="modal-overlay" @click.self="handleCloseModal">
      <div class="relative w-full px-6">
        <div class="absolute top-3 right-9 z-10 p-4" @click="handleCloseModal">
          <div class="p-1 bg-tp-yellow rounded-full flex items-center justify-center cursor-pointer">
            <img class="w-3 h-3" :src="close" alt="close-icon">
          </div>
        </div>
        <div class="flex flex-col gap-8 justify-center border-4 border-tp-yellow bg-tp-black rounded-3xl pt-4 pb-6">
          <p class="text-tp-yellow font-bold text-3xl px-6 border-b border-tp-yellow pb-3">{{ t('dj.activateQR') }}</p>
          <p class="text-tp-yellow font-semibold px-6">
            {{ t('dj.customizeDescription') }}
          </p>
          <div class="flex gap-6 px-6">
            <button class="flex-1 whitespace-nowrap bg-tp-yellow text-tp-black font-bold px-3 py-2 rounded-xl" @click="emitChooseManual">
              {{ t('dj.choose3') }}
            </button>
            <button class="flex-1 whitespace-nowrap bg-tp-yellow text-tp-black font-bold px-3 py-2 rounded-xl" @click="emitChooseTop">
              {{ t('dj.topVoted') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import close from '@/assets/images/black-close-icon.png';
  import { useI18n } from 'vue-i18n';
  
  export default {
    name: 'CustomizationModal',
    setup(_, { emit }) {
      const { t } = useI18n();
      const handleCloseModal = () => {
        emit('onCloseModal');
      };
  
      const emitChooseManual = () => {
        emit('chooseManual');
      };
  
      const emitChooseTop = () => {
        emit('chooseTop');
      };
  
      return {
        close,
        handleCloseModal,
        emitChooseManual,
        emitChooseTop,
        t
      };
    }
  };
  </script>
  